// extracted by mini-css-extract-plugin
module.exports = {"timeIconSize":"TimeZoneSwitchWidget__timeIconSize___3iioa","switchStyle":"TimeZoneSwitchWidget__switchStyle___1r-jB"};